import { render, staticRenderFns } from "./LotterySettingForm.vue?vue&type=template&id=38bc98fa&"
import script from "./LotterySettingForm.vue?vue&type=script&lang=js&"
export * from "./LotterySettingForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports